export const ERROR = 'error';
export const RESULT = 'result';